var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20Z",
    stroke: "#9DA4AB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63749 22.3627C8.81628 21.5424 8.16247 20.5702 7.71249 19.5002C7.24216 18.3933 6.99976 17.2029 6.99976 16.0002C6.99976 14.7975 7.24216 13.6071 7.71249 12.5002C8.16247 11.4302 8.81628 10.458 9.63749 9.6377",
    stroke: "#9DA4AB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3625 9.6377C23.1837 10.458 23.8375 11.4302 24.2875 12.5002C24.7578 13.6071 25.0002 14.7975 25.0002 16.0002C25.0002 17.2029 24.7578 18.3933 24.2875 19.5002C23.8375 20.5702 23.1837 21.5424 22.3625 22.3627",
    stroke: "#9DA4AB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10001 25.8996C4.82457 24.6218 3.80616 23.1112 3.1 21.4496C2.37393 19.7244 1.99991 17.8714 1.99991 15.9996C1.99991 14.1278 2.37393 12.2749 3.1 10.5496C3.80616 8.88804 4.82457 7.37739 6.10001 6.09961",
    stroke: "#9DA4AB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9 6.09961C27.1754 7.37739 28.1938 8.88804 28.9 10.5496C29.6261 12.2749 30.0001 14.1278 30.0001 15.9996C30.0001 17.8714 29.6261 19.7244 28.9 21.4496C28.1938 23.1112 27.1754 24.6218 25.9 25.8996",
    stroke: "#9DA4AB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.7c810832b70c59ac87d32977e7fb3013.svg";
export { ForwardRef as ReactComponent };